import { defineSaleProgress, hasAddress, isSaleCreated, isSaleStarted, type ProgressSaleData } from '../saleProgress'

interface LeadAssuranceProSanteData extends ProgressSaleData {
  leadType?: string | null
}

const TIMELINE = 'additionalSales:pulse.timeline.'

export default defineSaleProgress<LeadAssuranceProSanteData>({
  kind: 'lead',
  steps: [
    { key: 'address', label: `${TIMELINE}address`, done: hasAddress },
    { key: 'qualified', label: `${TIMELINE}qualified`, done: data => !!data.leadType },
    { key: 'lead_created', label: `${TIMELINE}lead_created`, done: isSaleCreated },
  ],
  status: (data, steps) => {
    if (steps[steps.length - 1]?.state === 'done') return 'signed'
    const isInProgress = isSaleStarted(data) || hasAddress(data) || steps.some(step => step.state === 'done')
    if (isInProgress) return 'progress'

    return 'new'
  },
})
